import { Avatar, Box, Flex, Text } from "@chakra-ui/react"
import { PublicationBlockAuthorPublic } from "../../client"
import { Link } from "@tanstack/react-router"

const AuthorBlock = ({ data }: { data: PublicationBlockAuthorPublic }) => {
    return (
        <Box my={10}>
            {data.authors?.map((author) => (
                author.show_profile ? (
                    <Link to="/autor/$authorId" params={{ authorId: author.id }}>
                        <Box key={author.fk_media_profile_pic?.id}>
                            <Flex alignItems="center">
                                <Avatar.Root size="2xl">
                                    <Avatar.Fallback
                                        name={ author.lastname && author.firstname
                                            ? `${author.lastname} ${author.firstname}`
                                            : author.firstname || author.lastname || author.abbreviation || undefined
                                        }
                                    />
                                    <Avatar.Image src={author.fk_media_profile_pic?.path.replace(/-(LG)\./, "-SM.")} />
                                </Avatar.Root>
                                <Flex direction="column" ml={4}>
                                    <Text color="dim" fontSize={15}>von</Text>
                                    <Text color="main">{`${author.firstname ?? ""} ${author.lastname ?? ""} ${author.abbreviation ? `(${author.abbreviation})` : ""}`}</Text>
                                </Flex>
                            </Flex>
                            {author.description &&
                                <Text mt={4}>{author.description}</Text>
                            }
                        </Box>
                    </Link>
                ) : (
                    <Box key={author.fk_media_profile_pic?.id}>
                        <Flex alignItems="center">
                            <Avatar.Root size="2xl">
                                <Avatar.Fallback
                                    name={ author.lastname && author.firstname
                                        ? `${author.lastname} ${author.firstname}`
                                        : author.firstname || author.lastname || author.abbreviation || undefined
                                    }
                                />
                                <Avatar.Image src={author.fk_media_profile_pic?.path.replace(/-(LG)\./, "-SM.")} />
                            </Avatar.Root>
                            <Flex direction="column" ml={4}>
                                <Text color="dim" fontSize={15}>von</Text>
                                <Text color="main">{`${author.firstname ?? ""} ${author.lastname ?? ""} ${author.abbreviation ? `(${author.abbreviation})` : ""}`}</Text>
                            </Flex>
                        </Flex>
                        {author.description &&
                            <Text mt={4}>{author.description}</Text>
                        }
                    </Box>
                )
                
            ))}
        </Box>
    )
}

export default AuthorBlock